import React, { useContext, useState } from 'react';
import './bepartner.css';
import { useTranslation } from 'react-i18next';
import DataContext from '../../context/Datacontext';
import useWindowSize from '../../hooks/useWindowSize';
import Way_go_logo from '../../images/way_go_bepartner.svg';
// import axios from '../../api/DataTrans';
const BePartner = () => {
    const {lang} = useContext(DataContext);
    const [t] = useTranslation("global");
    const {width} = useWindowSize();
    const [name,setName] = useState('');
    const [phone,setPhone] = useState('');
    const [address,setAddress] = useState('');
    const [skills,setSkills] = useState('');
    const sendEmploymentOrder = async (e) => {
        e.preventDefault();
        alert(`${name } wiating for yaser` );
        console.log(e)
    }
  return (
    <div className='bepartner_main' style={{
            // justifyContent:lang ? width > 600 ? 'flex-end' : 'center' : width > 600 ? 'flex-end' :  'center',
            flexDirection:lang ? width > 1000 ? 'row' : 'column' : width > 1000 ? 'row-reverse' :  'column',
            // paddingTop:width < 1000 ? "100px":'0px',
            paddingBottom:width < 1000 ? "100px":'0px'
            }}>
        <div className='bepartner_container_box'
             style={{
                // marginLeft:!lang && width > 1000 ? '50px' : '0px',marginRight:lang && width > 1000 ? '70px' : '0px',
                     marginTop:width<1000 ?'50px':'0px',flexDirection:width<425?'column':'row',
                     marginLeft:width > 1000 && !lang?'0px':'50px',marginRight:width > 1000 && lang?'0px':'50px',
             }}
        >
            <div className='bepartner_box_1'>
                <img src={Way_go_logo} style={{width:width<=1000 ? "80%" : "100%"}} alt=''/>
            </div>
        </div>
        <div className='bepartner_container' 
             style={{marginLeft:width > 600 && !lang?'100px':'0px',marginRight:width > 600 && lang?'100px':'0px',
                     justifyContent:lang?'flex-end':'flex-start',marginTop:width<1000 ? '45px':'0px'}}>
            <div className='bepartner_h1' style={{alignItems:lang?'flex-end':'flex-start'}}>
                <p className='bepartner_para'>{t("bepartner.increas")}</p>
                <p className='bepartner_para'>{t("bepartner.increas1")}</p>
            </div>
            <div className='bepartner_h2' style={{alignItems:lang?'flex-end':'flex-start',marginTop:'10px',marginBottom:'10px'}}>
                <p className='bepartner_para'>{t("bepartner.provide")}</p>
                <p className='bepartner_para'>{t("bepartner.provide1")}</p>
            </div>
            <form onSubmit={sendEmploymentOrder}>
                <div className='bepartner_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='bepartner_para'>{t("bepartner.name")}</p>
                    <input className='bepartnerInput' type='text' required onChange={(e) => setName(e.target.value)} value={name}
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    />
                </div>
                <div className='bepartner_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='bepartner_para'>{t("bepartner.phone")}</p>
                    <input className='bepartnerInput' maxLength={10} minLength={10} type='text' required onChange={(e) => setPhone(e.target.value)} value={phone}
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    />
                </div>
                <div className='bepartner_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='bepartner_para'>{t("bepartner.Garage")}</p>
                    <input className='bepartnerInput' type='text' required onChange={(e) => setAddress(e.target.value)} value={address} 
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    />
                </div>
                <div className='bepartner_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='bepartner_para'>{t("bepartner.Governorates")}</p>
                    <input className='bepartnerInput' type='text' required onChange={(e) => setSkills(e.target.value)} value={skills} 
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    />
                </div>
                <div className='bepartner_h3' style={{justifyContent:lang?'flex-end':'flex-start'}}>
                    <button type='submit' className='bepartner_sign'>{t("employment.send")}</button>
                </div>
            </form>
        </div>
    </div>
  )
}

export default BePartner